// src-mlr/views/clear-cache/clear-cache.view.js
import config from 'app/config';
import './clear-cache.scss';

class ClearCacheController {

  // Ensure all dependencies are correctly injected for minification
  static $inject = ["$sce"];

  /** @ngInject */
   constructor($sce) {
    this.config = config;
    this.ismobile = false;
    this.path = $sce.trustAsResourceUrl(`${config.pubPath}/clear-cache.tpl.html`);
  }
}

class ClearCacheComponent {
  constructor() {
    this.selector = 'clearcache';
    this.template = '<div ng-include="$ctrl.path"></div>';
    this.controller = ClearCacheController;
  }
}

export default angular
.module("clearcache.view", [])
.component("clearcache", new ClearCacheComponent())
.name;
